import { useEffect } from 'react';
import analytics from '@/services/analytics';
import { useAppSelector } from '@/hooks/store';

const ROLES_CLAIM = 'https://odeko.com/roles';

const AnalyticsProvider = ({
  children,
}: {
  children: JSX.Element;
}): JSX.Element => {
  const sub = useAppSelector((state) => state.auth.user?.sub);
  const email = useAppSelector((state) => state.auth.user?.email);
  const role = useAppSelector(
    (state) => (state.auth.user?.[ROLES_CLAIM] as string[])?.[0],
  );

  useEffect(() => {
    if (!sub) return;
    analytics.identify(sub, { email, role });
  }, [sub, email, role]);

  return children;
};

export default AnalyticsProvider;
